import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import KPMonthYearPicker from "../../../components/KPMonthYearPicker/KPMonthYearPicker";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";

import { uploadMultiFile } from "../../../reducer/file/action";
import { insertMonograph, updateMonograph, checkDuplicateMonograph } from "../../../reducer/monograph/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { notification } from "../../../reducer/home/action";
import DuplicateCheckModal from "../../../components/Monograph/DuplicateCheckModal";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";

import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import { set } from "immutable";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";

function MonographInsertModal(props) {
  const { inserting, setInserting } = props;

  const [values, setValues] = useState({
    purposeId: 5,
    type: "chapter",
    departmentId: props.profileDepartments?.[0]?.id || null,
    publishedDate: `01/01/${new Date().getFullYear()}`,
    year: new Date().getFullYear(),
  });
  const [detail, setDetail] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const currentYear = getCurrentSchoolYear();
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(null);

  // Tự gán bản thân vào danh sách tác giả
  React.useEffect(() => {
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInMonograph: "main",
          isInternal: true,
          externalName: "",
          timeAmount: null,
        },
      ]);
    }
  }, [inserting, props.profile?.id]);

  React.useEffect(() => {
    if (values?.type) setHelperText(false);
  }, [values?.type]);

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else {
      const newValues = { ...values, [name]: value };
      console.log(`🔍 handleChangeForm - name: ${name}, value:`, value, "newValues:", newValues);
      setValues(newValues);
    }
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInMonograph: "member",
      isInternal: true,
      externalName: "",
      timeAmount: null,
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const insertMonograph = async () => {
    const d = new Date();
    const tempListMember = values?.listMember?.split(",").map((author) => author.trimStart());

    // Convert publishedDate từ Date object hoặc string về ISO string
    let publishedDateToSend = values?.publishedDate;
    if (publishedDateToSend) {
      if (typeof publishedDateToSend === "string" && publishedDateToSend.includes("/")) {
        // Nếu là string format "01/mm/yyyy", convert sang Date rồi sang ISO
        const parts = publishedDateToSend.split("/");
        if (parts.length === 3) {
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          publishedDateToSend = new Date(year, month - 1, day, 12, 0, 0);
        }
      }
      // Nếu là Date object, giữ nguyên để axios tự serialize
    }

    console.log("📅 Monograph Insert - publishedDate:", values?.publishedDate);
    console.log("📤 Monograph Insert - publishedDateToSend:", publishedDateToSend);

    let result = await props
      .insertMonograph(props.profile?.id, {
        ...values,
        publishedDate: publishedDateToSend,
        listMember: tempListMember,
        dashboardYear: values?.year,
        monographProfile: profileList,
      })
      .then(async (response) => {
        if (response.success && newFiles.length > 0) {
          const uploadResult = await props.uploadMultiFile(response.data.id, newFiles, "monograph");
          if (uploadResult.success) {
            props.updateMonograph(response.data.id, {
              ...response.data,
              fileUrl: uploadResult.data.join("||"),
            });
          }
        }
        if (response.success) {
          props.statisticUnaccepted({
            departmentId: 0,
            profileId: props.profile?.id,
          });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
        return response.success;
      });
  };

  const checkForDuplicates = async (title) => {
    if (!title || title.trim() === "") {
      return { hasDuplicates: false, data: [] };
    }

    const result = await props.checkDuplicateMonograph({
      publicationType: "monographs",
      title: title.trim(),
    });

    if (result.success && result.data && result.data.length > 0) {
      return { hasDuplicates: true, data: result.data };
    }

    return { hasDuplicates: false, data: [] };
  };

  const handleSelectDuplicate = (item) => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);
    setInserting(false);

    setValues(null);
    setProfileList([]);
    setNewFiles([]);
    setHelperText(false);

    const monographToEdit = {
      ...item.monograph,
      monographProfile: item.monographProfile || [],
      _fromDuplicate: true,
    };

    if (props.setUpdating) {
      props.setUpdating(monographToEdit);
    }
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);

    if (pendingSubmit) {
      proceedWithSubmit(pendingSubmit);
      setPendingSubmit(null);
    }
  };

  const proceedWithSubmit = (submitData) => {
    setInserting(false);

    submitData.insertAction().then((success) => {
      if (success) {
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });

    setValues(null);
    setProfileList([]);
    setNewFiles([]);
  };

  const handleCloseInsertModal = () => {
    setInserting(false);
    setValues(null);
    setProfileList([]);
    setNewFiles([]);
    setHelperText(false);
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);
  };

  const handleSubmit = async (e) => {
    // check title, numOfMember, type
    if (!values?.title || !values?.numOfMember || !values?.type) {
      setHelperText(true);
      return;
    }

    // Validate at least one internal member
    const hasInternalMember = profileList.some((e) => e.isInternal === true);
    if (!hasInternalMember) {
      props.pushNoti({
        type: "warning",
        message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
      });
      return;
    }

    const duplicateCheck = await checkForDuplicates(values?.title);

    const submitData = {
      insertAction: () => insertMonograph(),
    };

    if (duplicateCheck.hasDuplicates) {
      setDuplicateList(duplicateCheck.data);
      setDuplicateModalOpen(true);
      setPendingSubmit(submitData);
      return;
    }

    proceedWithSubmit(submitData);
  };

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === 0)?.timeResearchDetail || [];

  // timeResearchDetailList = timeResearchDetailList.filter((e) => !e.allowedUpdateNum && e.type === "monograph");

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type === "monograph");
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const yearList = [];
  // console.log(props.timeResearchInformationList);
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  return (
    <Dialog fullWidth keepMounted maxWidth="lg" open={inserting} onClose={handleCloseInsertModal} disableBackdropClick>
      <DialogTitle>Thêm sách</DialogTitle>
      <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
        <div
          style={{
            display: "flex",
            flex: "1 1 auto",
            minWidth: 0,
            paddingRight: 16,
            alignItems: "flex-start",
          }}
        >
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={7}>
              <TextField
                fullWidth
                size="small"
                label="Tên sách/ Tiêu đề"
                variant="outlined"
                value={values?.title?.toString() || ""}
                required
                error={helperText && !values?.title}
                helperText={helperText && !values?.title ? "Vui lòng nhập tên sách/ tiêu đề" : ""}
                onChange={(event) => handleChangeForm("title", event.target.value)}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Mã CTKH"
                value={values?.hemisCode || ""}
                onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng tác giả"
                value={values?.numOfMember || ""}
                required
                error={helperText && !values?.numOfMember}
                helperText={helperText && !values?.numOfMember ? "Vui lòng nhập số lượng tác giả" : ""}
                onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                size="small"
                options={(props.departmentList || []).filter((d) => d.id !== 0)}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                  null
                }
                onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id)}
                renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Nhà xuất bản"
                value={values?.publisher || ""}
                onChange={(event) => handleChangeForm("publisher", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tác giả"
                variant="outlined"
                value={values?.listMember || ""}
                multiline
                rows={4}
                onChange={(event) => handleChangeForm("listMember", event.target.value)}
              />
            </Grid>
            <Grid item xs={5}>
              <KPMonthYearPicker
                fullWidth
                label="Tháng/Năm xuất bản"
                required
                value={values?.publishedDate || `01/01/${new Date().getFullYear()}`}
                setValue={(newValue) => {
                  console.log("🔍 Insert - KPMonthYearPicker setValue called with:", newValue);
                  // newValue có dạng "01/mm/yyyy" - Lưu trực tiếp string này vào state
                  const parts = newValue.split("/");
                  if (parts.length === 3) {
                    const year = parseInt(parts[2], 10);

                    // Cập nhật CẢ publishedDate VÀ year trong một lần setState
                    console.log("✅ Insert - Setting publishedDate to string:", newValue);
                    setValues({
                      ...values,
                      publishedDate: newValue,
                      year: year,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Số trang"
                variant="outlined"
                value={values?.pageNumber || ""}
                onChange={(event) => handleChangeForm("pageNumber", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                size="small"
                label="Số ISBN"
                variant="outlined"
                value={values?.isbn || ""}
                onChange={(event) => handleChangeForm("isbn", event.target.value)}
              />
            </Grid>
            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Điểm GS-PGS"
                variant="outlined"
                value={values?.score || ""}
                onChange={(event) => handleChangeForm("score", parseFloat(event.target.value))}
              />
            </Grid> */}
            <Grid item xs={4}>
              <FormControl fullWidth variant="outlined" size="small" error={helperText && !values?.type}>
                <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Phân loại</InputLabel>
                <Select
                  native
                  fullWidth
                  value={values?.type || ""}
                  onChange={(event) => handleChangeForm("type", event.target.value)}
                >
                  {/* <option value={null} /> */}
                  <option value="chapter">Chương sách</option>
                  <option value="monograph">Chuyên khảo</option>
                  <option value="reference">Tham khảo</option>
                  <option value="curriculum">Giáo trình</option>
                </Select>
                {helperText && !values?.type && <FormHelperText>Không được bỏ trống</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Ngôn ngữ</InputLabel>
                <Select
                  native
                  fullWidth
                  value={values?.language || ""}
                  onChange={(event) => handleChangeForm("language", event.target.value)}
                >
                  <option value={null} />
                  <option value="english">Tiếng Anh</option>
                  <option value="other">Khác</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="purpose-label"
                  value={values?.purposeId ?? "none"}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes
                    .filter((e) => e.name !== "bonusCalculated")
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.description}
                      </option>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            {values?.purposeId === 5 && (
              <>
                {/* <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => setTimeResearchYear(parseInt(event.target.value))}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid> */}
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    error={!values?.timeResearchDetailCode}
                  >
                    {timeResearchDetailList.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>{`${e.description} - ${e.value}(h)`}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value={null} disabled>
                        Chưa có dữ liệu
                      </MenuItem>
                    )}
                  </TextField>
                  {!values?.timeResearchDetailCode && <FormHelperText error>Phải chọn một nhiệm vụ!</FormHelperText>}
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values?.isOvertimeCountable || false}
                    disabled={props.role !== "sudo-admin"}
                    onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                    color="primary"
                  />
                }
                label="Tính giờ ngoài quy chế"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Số giờ ngoài quy chế"
                variant="outlined"
                value={values?.overtimeHours ?? ""}
                disabled={props.role !== "sudo-admin" || !values?.isOvertimeCountable}
                onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                inputProps={{
                  min: 0,
                  step: 0.1,
                }}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 4 : 3}>
                      <Autocomplete
                        disableClearable
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={profileListFromProps?.find((profile) => profile.id === e.profileId)}
                        onChange={(event, profile) => {
                          if (profileList[index]?.profileId === values?.profileIdForKpi)
                            handleChangeForm("profileIdForKpi", null);
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 4 : 3}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 4 : 2}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInMonograph-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="roleInMonograph-label"
                        onChange={(event) => handleChangeProfileList(index, "roleInMonograph", event.target.value)}
                      >
                        <option value="main">Chủ biên</option>
                        <option value="member">Đồng tác giả</option>
                        {/* <option value="mainOther">Chủ biên tính hộ</option>
                        <option value="memberOther">Đồng tác giả tính hộ</option> */}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 2 : 1}>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      variant="outlined"
                      label="Số giờ"
                      value={e?.timeAmount || ""}
                      onChange={(event) =>
                        handleChangeProfileList(index, "timeAmount", parseFloat(event.target.value) || null)
                      }
                    />
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            flexDirection: "column",
            display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
          }}
        >
          <EmploymentContractTable
            contract={detail}
            contractList={contractList}
            kpiIdForKpi={values?.kpiIdForKpi}
            contractIdForKpi={values?.contractIdForKpi}
            setDetail={setDetail}
            values={values}
            setValues={setValues}
            handleChangeForm={handleChangeForm}
          />
          <EmploymentContractDetailTable kpi={detail} />
        </div>
        <div style={{ flex: "0 0 380px", paddingLeft: 16, borderLeft: "1px solid #e0e0e0" }}>
          <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 600 }}>
            File minh chứng
          </Typography>
          <MultiFileManager fileUrls={[]} setFileUrls={() => {}} newFiles={newFiles} setNewFiles={setNewFiles} />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px 8px 24px" }}>
        <Grid container justifyContent={"space-between"}>
          <div />
          <div style={{ float: "right" }}>
            <Button variant="outlined" color="secondary" onClick={handleCloseInsertModal} style={{ marginRight: 4 }}>
              Huỷ
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleSubmit()}
              disabled={values?.purposeId === 5 && !values?.timeResearchDetailCode}
            >
              Xác nhận
            </Button>
          </div>
        </Grid>
      </DialogActions>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        onClose={handleCloseDuplicateModal}
        duplicateList={duplicateList}
        onSelectDuplicate={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  listById: select(state, "monographReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
});

const mapDispatchToProps = (dispatch) => ({
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertMonograph: (profileId, payload) => dispatch(insertMonograph(profileId, payload)),
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  updateMonograph: (profileId, payload) => dispatch(updateMonograph(profileId, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  checkDuplicateMonograph: (payload) => dispatch(checkDuplicateMonograph(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(MonographInsertModal));

